import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConnectionService } from 'ng-connection-service';
import { MenuItem } from 'primeng/api';
import { environment } from 'src/environments/environment.prod';
import { FirbaseMessagingService } from '../services/firbase-messaging/firbase-messaging.service';
import { UtilsService } from '../services/utils/utils.service';
import { CommonFunctions } from '../Utilities/CommonFunctions';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  firstName = '';
  lastName = '';
  avatarName = '';
  profileUrl = '';
  imageInputError = false
  status = 'ONLINE';
  isConnected = true;
  noInternetConnection: boolean = false;
  items: MenuItem[] = [];
  msgItems: MenuItem[] = [];
  messageCount: string = '0';
  notificationCount: string = '0';

  constructor(
    private router: Router,
    private utilsService: UtilsService,
    private connectionService: ConnectionService,
    private messagingService: FirbaseMessagingService
  ) {
    this.connectionService.monitor().subscribe(isConnected => {
      this.isConnected = isConnected;
      if (this.isConnected) {
        this.status = "ONLINE";
        this.noInternetConnection = false;
      }
      else {
        this.status = "OFFLINE";
        this.noInternetConnection = true;
      }
    })
    this.messagingService.messageCount.subscribe(
      (messageCount) => {
        this.messageCount = messageCount
        // this.showSuccessToastMsg(newPayload?.notification?.title, newPayload?.notification?.body)
      }
    )
    this.messagingService.notificationCount.subscribe(
      (notificationCount) => {
        this.notificationCount = notificationCount
        // this.showSuccessToastMsg(newPayload?.notification?.title, newPayload?.notification?.body)
      }
    )
    this.utilsService.reloadProfile.subscribe(
      (isClicked) => {
        if (isClicked) {
          this.getProfile()
        }
      }
    )

  }

  ngOnInit(): void {
    this.getProfile()
    this.items = [{
      label: 'My Profile',
      icon: 'pi pi-user',
      routerLink: ['/profile']
      // command: () => {
      //     this.update();
      // }
    },
    {
      label: 'Log Out',
      icon: 'pi pi-power-off',
      routerLink: ['/logout']
    }];

    this.msgItems = [
      {
        label: 'message 1',
      },
      { separator: true },
      {
        label: 'message 2',
      },
      { separator: true },
      {
        label: 'message 3',
      },
    ]
  }

  getProfile() {
    var user = CommonFunctions.getUser();
    console.log('Header response --->> ' + user.firstName);
    this.avatarName = user.firstName.charAt(0) + user.lastName.charAt(0);
    this.firstName = user.firstName;
    this.lastName = user.lastName;
    this.imageInputError = false;
    this.profileUrl = environment.API_URL + user.profileImage
  }

  fileFailedToLoad(event: any) {
    console.log(event)
    this.imageInputError = true;
    this.profileUrl = 'assets/images/default-user.png'
  }

  openClientCommunication() {
    if (this.router.url.split('/')[1] != "client-communication") {
      this.router.navigateByUrl('/client-communication')
    }
  }

  changeState() {
    this.utilsService.changeState()
  }

  changeMobileMenuState() {
    this.utilsService.changeMobileMenuState(true)
  }

  setIsVisibleSidebar(isVisible: boolean) {
    this.utilsService.setIsVisibleSidebar(isVisible);
  }
}
